import type { CustomAlertType } from '@customTypes/alert';

const DESIGN_ALERT: CustomAlertType = {
  key: 'design-alert',
  showAlert: false,
  text: 'Сроки обработки заявок временно увеличены до 3-4 рабочих дней. Спасибо за понимание!',
  bgColor: '#F4F5FB',
  tooltipText: '_',
  links: [],
  pathname: '/design-photobook',
};

export const CUSTOM_ALERTS = [DESIGN_ALERT];
